
import React, { useState, useRef } from 'react';
import './SideMenu.css';
import { useSelector } from 'react-redux';
import { category, brands, store, influencer, show_brand, show_Influencer, show_store } from "../Redux/API";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { category_data } from "../Redux/HomeSlice";
import { useTranslation } from 'react-i18next';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css'; 


const SideMenu = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();


    const categorys = useSelector(state => state.Data.category);
    const brand = useSelector(state => state.Data.brands);
    const Stores = useSelector(state => state.Data.store);
    const influencers = useSelector(state => state.Data.influencer);

    useEffect(() => {
        dispatch(category());
        dispatch(brands());
        dispatch(store());
        dispatch(influencer());
    }, [dispatch]);

    const sideMenuItems = [
        { id: 1, label: t('categories'), subMenu: categorys?.data?.data || [] },
        { id: 2, label: t('brands'), subMenu: brand?.data?.data?.brands || [] },
        { id: 3, label: t('stores'), subMenu: Stores?.data?.data || [] },
        { id: 4, label: t('influencers'), subMenu: influencers?.data?.data || [] },
        // { id: 5, label: t('settings'), subMenu: [] },
        { id: 6, label: t('help'), subMenu: [] },
    ];

    const [activeMenu, setActiveMenu] = useState(null);
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const [activeSubSubMenu, setActiveSubSubMenu] = useState(null);

    const toggleSubMenu = (id) => {
        const selectedItem = sideMenuItems.find((item) => item.id === id);
    
        // التحقق إذا كانت العنصر هي "Settings" أو "Help"
        if (selectedItem.label === 'Settings') {
            gotoSettings();
        } else if (selectedItem.label === 'Help') {
            gotoHelp();
        } else {
            // باقي العناصر تتبع السلوك الطبيعي لعرض القائمة الفرعية
            setActiveMenu(activeMenu === id ? null : id);
            setActiveSubMenu(null); // إعادة تعيين القائمة الفرعية عند تغيير العنصر الرئيسي
            // setActiveSubSubMenu(null); // إعادة تعيين القائمة الفرعية عند تغيير العنصر الرئيسي
        }
    };
    

    const toggleSubMenu2 = (subItem) => {
        if (subItem.subcategories && subItem.subcategories.length > 0) {
            setActiveSubMenu(activeSubMenu === subItem ? null : subItem);
        } else {
            navigateToScreen(subItem);
        }
    };

    const navigateToScreen = (subItem) => {
        switch (activeMenu) {
            case 1:
                gotoCategory(subItem);
                break;
            case 2:
                gotoBrand(subItem.id);
                break;
            case 3:
                gotoStore(subItem.id);
                break;
            case 4:
                gotoInfluencer(subItem.id);
                break;
            default:
                break;
        }
    };

    const closeSubMenu = () => {
        setActiveMenu(null);
        closeSubMenu2();
    };

    const handleClose = () => {
        onClose();
        closeSubMenu();
        closeSubMenu2();
    };

    const closeSubMenu2 = () => {
        setActiveSubMenu(null);
    };

    const gotoCategory = (category) => {
        localStorage.setItem('categoryData', JSON.stringify(category));
        dispatch(category_data(category));
        navigate('/SubSupCategory');
    };

    const gotoBrand = (id) => {
        localStorage.setItem('brandId', id);
        dispatch(show_brand({ id }));
        navigate('/Brand');
    };

    const gotoInfluencer = (id) => {
        localStorage.setItem('InfluencerId', id);
        dispatch(show_Influencer({ id }));
        navigate('/Influencer');
    };

    const gotoStore = (id) => {
        localStorage.setItem('storeId', id);
        dispatch(show_store({ id }));
        navigate('/Store');
    };
    
    const gotoSettings = (id) => {
        navigate('/Settings');
    };
    const gotoHelp = (id) => {
        navigate('/Help');
    };
    
    const menuRef = useRef(null);
    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            handleClose(); 
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div className="side-menu-container" ref={menuRef}>
            <div className={`side-menu ${isOpen ? 'open' : ''}`} style={{ maxHeight: '60vh', overflow: 'hidden' }}>
                <button className="close-button" onClick={handleClose}>×</button>
                {sideMenuItems.map((item) => (
                    <div key={item.id} className="menu-item">
                        <div className="menu-item" key={item.id}>
                            <div onClick={() => toggleSubMenu(item.id)} className="menu-label">
                                <p>{item.label}</p>
                                {item.label !== 'Settings' && item.label !== 'Help' && (
                                    <span className={`arrow ${activeMenu === item.id ? 'down' : 'up'}`}>▼</span>
                                )}
                            </div>
                        </div>
                        {/* <div onClick={() => toggleSubMenu(item.id)} className="menu-label">
                            <p>{item.label}</p>
                            <span className={`arrow ${activeMenu === item.id ? 'down' : 'up'}`}>▼</span>
                        </div> */}
                    </div>
                ))}
            </div>

            <div className={`side-sub-menu ${activeMenu ? 'open' : ''}`} style={{ maxHeight: '70vh', overflow: 'hidden' }}>
                <button className="close-button" onClick={closeSubMenu}>×</button>
                <PerfectScrollbar>
                    {activeMenu && sideMenuItems.find((item) => item.id === activeMenu).subMenu.map((subItem, index) => (
                        <div key={index} className="menu-item" onClick={() => toggleSubMenu2(subItem)}>
                            <div className="menu-label">
                                <p>{subItem.name || subItem}</p>
                                {subItem.subcategories?.length > 0 && (
                                    <span className={`arrow ${activeSubMenu === subItem ? 'rotate' : ''}`}>▼</span>
                                )}
                            </div>
                        </div>
                    ))}
                </PerfectScrollbar>
            </div>

            <div className={`side-sub-sub-menu ${activeSubMenu ? 'open' : ''}`} style={{ maxHeight: '80vh', overflow: 'hidden' }}>
                <button className="close-button" onClick={closeSubMenu2}>×</button>
                <PerfectScrollbar>
                    {activeSubMenu && activeSubMenu.subcategories?.map((item, idx) => (
                        <div key={idx} className="menu-item" onClick={() => navigateToScreen(item)}>
                            <p className="menu-label">{item.name}</p>
                        </div>
                    ))}
                </PerfectScrollbar>
            </div>
        </div>
    );
};

export default SideMenu;
